export default "__VITE_ASSET__CKMjTnDj__"